module.exports = __webpack_public_path__ + "img/bg.2c24deb.png";